import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProjectCard = ({ project, onViewDetails, onShare }) => {
  return (
    <div className="glass-morph bg-card/80 backdrop-blur-md rounded-xl border border-white/10 hover:border-brand-cyan/30 shadow-brand hover:shadow-brand-lg transition-all duration-300 overflow-hidden group">
      {/* Project Image */}
      <div className="relative aspect-video overflow-hidden">
        <Image
          src={project.image}
          alt={project.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-4 left-4 right-4 flex justify-between items-end">
            <div className="flex space-x-2">
              {project.tags.slice(0, 2).map((tag, index) => (
                <span
                  key={index}
                  className="px-2 py-1 bg-white/20 backdrop-blur-sm rounded-full text-xs text-white font-medium"
                >
                  {tag}
                </span>
              ))}
            </div>
            
            <button
              onClick={() => onShare(project)}
              className="w-8 h-8 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-colors duration-200"
            >
              <Icon name="Share2" size={16} className="text-white" />
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="p-6 space-y-4">
        {/* Header */}
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <span className="px-3 py-1 bg-brand-cyan/20 text-brand-cyan border border-brand-cyan/30 rounded-full text-sm font-medium">
              {project.industry}
            </span>
            <span className="text-sm text-slate-600">
              {project.duration}
            </span>
          </div>

          <h3 className="text-xl font-bold text-slate-900 font-heading line-clamp-2">
            {project.title}
          </h3>

          <p className="text-slate-700 line-clamp-3">
            {project.description}
          </p>
        </div>

        {/* Key Metrics */}
        <div className="grid grid-cols-2 gap-4">
          {project.keyMetrics.slice(0, 2).map((metric, index) => (
            <div key={index} className="text-center p-3 bg-primary/20 border border-primary/30 rounded-lg">
              <div className="text-lg font-bold text-brand-cyan">
                {metric.value}
              </div>
              <div className="text-xs text-slate-600">
                {metric.label}
              </div>
            </div>
          ))}
        </div>

        {/* Technologies */}
        <div className="space-y-2">
          <div className="flex items-center space-x-2">
            <Icon name="Cpu" size={16} className="text-slate-600" />
            <span className="text-sm font-medium text-slate-700">Technologies</span>
          </div>
          <div className="flex flex-wrap gap-1">
            {project.technologies.slice(0, 4).map((tech, index) => (
              <span
                key={index}
                className="px-2 py-1 bg-gray-100 text-slate-800 border border-gray-200 rounded text-xs"
              >
                {tech}
              </span>
            ))}
            {project.technologies.length > 4 && (
              <span className="px-2 py-1 bg-gray-100 text-slate-800 border border-gray-200 rounded text-xs">
                +{project.technologies.length - 4} more
              </span>
            )}
          </div>
        </div>

        {/* Client Info */}
        <div className="flex items-center space-x-3 pt-2 border-t border-white/20">
          <div className="w-8 h-8 bg-brand-cyan/20 border border-brand-cyan/30 rounded-full flex items-center justify-center">
            <Icon name="Building2" size={16} className="text-brand-cyan" />
          </div>
          <div className="flex-1">
            <div className="text-sm font-medium text-slate-900">
              {project.client}
            </div>
            <div className="text-xs text-slate-600">
              {project.clientRole}
            </div>
          </div>
        </div>

        {/* Action Button */}
        <Button
          variant="outline"
          fullWidth
          onClick={() => onViewDetails(project)}
          iconName="ArrowRight"
          iconPosition="right"
          className="mt-4"
        >
          View Case Study
        </Button>
      </div>
    </div>
  );
};

export default ProjectCard;